import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1012782631449952';
const FB_SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js';
/**
 * Meta (Facebook) Pixel — base install firing a PageView on load.
 * Robust loader that appends the script to <head> instead of relying on an
 * existing <script> tag (which may not exist in sandboxed/iframe environments).
 */
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    // Define the fbq stub + queue (official base code, minus the fragile
    // getElementsByTagName('script')[0] insertion).
    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      w.fbq = n;
      // Load the external script safely.
      if (!document.getElementById('meta-pixel-script')) {
        const t = document.createElement('script');
        t.id = 'meta-pixel-script';
        t.async = true;
        t.src = FB_SCRIPT_SRC;
        (document.head || document.documentElement).appendChild(t);
      }
    }
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-18">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-19" />
    </noscript>;
}